import {LivenessAdvancedContent} from 'components/SmartKYC';

export const LivenessAdvanced = () => <LivenessAdvancedContent />;
